import {AutoComplete} from "primereact/autocomplete";
import React, {useEffect, useState} from "react";
import GeneralUtils from "../../utils/GeneralUtils";
import {useNavigate} from "react-router-dom";
import {SearchService} from "../../service/SearchService";
const Search = (props) => {
    const [phrase, setPhrase] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [autoCompleteTimeout, setAutoCompleteTimeout] = useState(null);
    // const [isSearchActive, setIsSearchActive] = useState(false);

    const navigate = useNavigate();

    const searchService = new SearchService();

    useEffect(() => {
        if (!GeneralUtils.isNullOrEmpty(phrase) && phrase.length>2) {
            if (autoCompleteTimeout != null) {
                clearTimeout(autoCompleteTimeout);
            }
            setAutoCompleteTimeout(
                setTimeout(() => {
                    searchService.suggestions(phrase).then(response => setSuggestions(response));
                    setAutoCompleteTimeout(null);
                }, 750)
            );
        }
    }, [phrase]);
    const handleSearch = (e) => {
        setPhrase(e.query);
    };

    const onSelect =  (e) => {
        setPhrase(null);
        if(typeof e.value === 'object'){
            navigate(`/course/${e.value.id}`);
        }else{
            navigate(`/courses/search/?q=${e.value}`);
        }
    }

    const onKeyDown =  (e) => {
        const {name, value} = e.target;
        if (e.key === "Enter") {
            navigate(`/courses/search/?q=${value}`);
            // setPhrase(null);
            // setSuggestions(null);
        }
    }

    const itemTemplate = (item) => {
        return (
            <div className="flex align-items-center">
                {item.image240x135 ?
                    <img src={item.image240x135} alt={item.title} className={`mr-2`} style={{width: '60px'}}/> :
                    <img src="/assets/images/placeholderImage.jpg" alt={item.title} className={`mr-2`} style={{width: '60px'}}/>
                }
                <div>{item.title}</div>
            </div>
        );
    };

    return (
        <div className="search p-input-icon-left">
            <i className="pi pi-search p-disabled"/>
            <AutoComplete field="title" suggestions={suggestions} completeMethod={handleSearch}
                          value={phrase} onChange={(e) => {setPhrase(e.value)}} onSelect={onSelect}
                          onKeyDown={onKeyDown} itemTemplate={itemTemplate}
                // onClick={()=>setIsSearchActive(!isSearchActive)}
                          placeholder="Dilediğiniz şeyi arayın"/>
        </div>
    );
}

export default Search;
